export { default as HeatMap } from './HeatMap'

export type HeatMapData = {
  x: number
  y: number
  z: number
  value: number
  radius?: number
}

export interface HeatMapnterface {
  data: HeatMapData[]

  setData(data: HeatMapData[])
}
